import { httpService } from '@/services/HttpService';

class DedicatedMachineDetailsService {
  getDedicatedMachineDetails(workspaceId: number, regionId: number, dedicatedMachineId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/dm/reservations/${dedicatedMachineId}`);
  }
  editDedicatedMachineDetails(
    workspaceId: number,
    regionId: number,
    dedicatedMachineId: number,
    detailsData: any
  ): Promise<any> {
    return httpService.put(
      `workspaces/${workspaceId}/regions/${regionId}/dm/reservations/${dedicatedMachineId}`,
      detailsData
    );
  }
  deleteDedicatedMachine(workspaceId: number, regionId: number, dedicatedMachineId: number): Promise<any> {
    return httpService.delete(
      `workspaces/${workspaceId}/regions/${regionId}/dm/reservations/${dedicatedMachineId}`,
      ''
    );
  }
  powerOffDedicatedMachine(workspaceId: number, regionId: number, dedicatedMachineId: number): Promise<any> {
    return httpService.post(
      `workspaces/${workspaceId}/regions/${regionId}/dm/reservations/${dedicatedMachineId}/power_off`,
      ''
    );
  }
  powerOnDedicatedMachine(workspaceId: number, regionId: number, dedicatedMachineId: number): Promise<any> {
    return httpService.post(
      `workspaces/${workspaceId}/regions/${regionId}/dm/reservations/${dedicatedMachineId}/power_on`,
      ''
    );
  }
  restartDedicatedMachine(workspaceId: number, regionId: number, dedicatedMachineId: number): Promise<any> {
    return httpService.post(
      `workspaces/${workspaceId}/regions/${regionId}/dm/reservations/${dedicatedMachineId}/reset`,
      ''
    );
  }
  getNetworkCards(workspaceId: number, regionId: number, dedicatedMachineId: number): Promise<any> {
    return httpService.get(
      `workspaces/${workspaceId}/regions/${regionId}/dm/nics?dm_reservation_id=${dedicatedMachineId}`
    );
  }
  getAllNetworkCards(workspaceId: number, regionId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/dm/nics`);
  }
  updateNetworkCard(workspaceId: number, regionId: number, networkCardId: number, nicData: any): Promise<any> {
    return httpService.put(`workspaces/${workspaceId}/regions/${regionId}/dm/nics/${networkCardId}`, nicData);
  }
}

export const dedicatedMachineDetailsService = new DedicatedMachineDetailsService();
